import { useTranslation } from 'react-i18next';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

import { getFamilyList } from '../../organisms-cms/child-bio/utils/familyList';
import { listFormat } from '../../organisms-cms/child-bio/utils/simpleList';
import { getAge } from '../../utils/child-bio';

type ChildBioSummaryProps = {
  details: ChildDetails;
  translatedCountry: string;
  translatedLanguage: string;
  className?: string;
};

export const ChildBioSummary = ({
  className = 'mb-comfy-sm',
  details,
  translatedCountry,
  translatedLanguage,
}: ChildBioSummaryProps) => {
  const { t } = useTranslation(['bio']);

  const age = getAge(details.ageInYearsAndMonths);

  return (
    <div className={className}>
      {t('bio:summary', {
        context: details.gender,
        childName: details.name.preferred,
        koreanName: details.hangul.preferred || details.name.preferred,
        age,
        country: translatedCountry,
        family: getFamilyList(details.householdList[0].householdMemberList),
        favoriteActivities:
          details.interests.thingsILike.length > 0
            ? t('bio:favoriteActivities', {
                context: details.gender,
                favorites: listFormat(details.interests.thingsILike),
              })
            : '',
        projectActivities:
          details.interests.favoriteProjectActivity.length > 0
            ? t('bio:projectActivities', {
                context: details.gender,
                activities: listFormat(
                  details.interests.favoriteProjectActivity,
                ),
              })
            : '',
        language: translatedLanguage,
      })}
    </div>
  );
};
